import React from 'react';

import Weight from "components/controls/Weight";
import { useTranslation } from "react-i18next";
import { Flex } from 'antd';

import './OptionsTab.sass';

export const OptionsTab = (props: any) => {

    const { t } = useTranslation();

    const isLastEvaluationVisible = props.preferences?.evaluatedAt !== undefined ? props.preferences?.evaluatedAt : true
    const isRiskCategoryVisible = props.preferences?.riskCategory !== undefined ? props.preferences?.riskCategory : true
    const isStakeholdersVisible = props.preferences?.stakeholders || false
    const isMatchingROVisible = props.preferences?.matchingRO || false

    const areLinksVisible = props.preferences?.allLinks !== undefined ? props.preferences?.allLinks : false
    const showStakes = props.preferences?.stakesChart !== undefined ? props.preferences?.stakesChart : true
    const showStakeholders = props.preferences?.stakeholdersChart !== undefined ? props.preferences?.stakeholdersChart : true
    const showRisks = props.preferences?.risksChart !== undefined ? props.preferences?.risksChart : true
    const showOpportunities = props.preferences?.opportunitiesChart !== undefined ? props.preferences?.opportunitiesChart : true
    const isDescriptionVisible = props.preferences?.description !== undefined ? props.preferences?.description : true

    // En mode Visualisation (onglet viz) il n'y a pas de tableau : la section
    // « Colonnes affichées » n'a aucun sens. `displayColumns` (faux en viz)
    // la masque, on ne garde alors que « Options de visualisation ». Par
    // défaut vrai pour ne rien casser sur les pages qui ne le fournissent pas.
    const displayColumns = props.displayColumns !== undefined ? props.displayColumns : true

    return (
        <div className="OptionsTab">

            {displayColumns && <>
                <strong
                    className="text-left mt-1"
                    style={{ marginBottom: '0.5rem' }}
                >
                    {t('pages.risks.tabs.filters.displayed_columns')}
                </strong>
                <div className="columnsList">
                    <Flex className="mb-05 text-left">
                        <div style={{ width: "95%" }}>
                            {t('models.risk.fields.evaluated_at')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'evaluatedAt',
                                    !isLastEvaluationVisible
                                );
                            }}
                        >
                            {isLastEvaluationVisible ? 1 : 0}
                        </Weight>
                    </Flex>
                    <Flex className="mb-05 text-left">
                        <div style={{ width: "95%" }}>
                            {t('models.risk.fields.risk_category')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'riskCategory',
                                    !isRiskCategoryVisible
                                );
                            }}
                        >
                            {isRiskCategoryVisible ? 1 : 0}
                        </Weight>
                    </Flex>
                    <Flex className="mb-05 text-left">
                        <div style={{ width: "95%" }}>
                            {t('models.item.name_plural')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'stakeholders',
                                    !isStakeholdersVisible
                                );
                            }}
                        >
                            {isStakeholdersVisible ? 1 : 0}
                        </Weight>
                    </Flex>
                    <Flex className="mb-05 text-left">
                        <div style={{ width: "95%" }}>
                            {t('models.risk.fields.matching_risks')}
                            /
                            {t('models.risk.fields.matching_opportunity')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'matchingRO',
                                    !isMatchingROVisible
                                );
                            }}
                        >
                            {isMatchingROVisible ? 1 : 0}
                        </Weight>
                    </Flex>

                    <Flex className="mb-05 text-left">
                        <div style={{ width: "95%" }}>
                            {t('pages.risks.tabs.options.show_description', { defaultValue: 'Afficher la description' })}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'description',
                                    !isDescriptionVisible
                                );
                            }}
                        >
                            {isDescriptionVisible ? 1 : 0}
                        </Weight>
                    </Flex>

                </div>
            </>}

            {/* Options de visualisation : pertinentes uniquement en mode Viz
                (pas sur les onglets listes Risques/Ouvertures). Pierre. */}
            {!displayColumns && <>
                <strong
                    className="text-left mt-1"
                    style={{ marginBottom: '0.5rem' }}
                >
                    {t('pages.risks.tabs.filters.visualization_options')}
                </strong>
                <div className="columnsList">
                    <Flex className="mb-05">
                        <div style={{ width: "95%" }} className="text-left">
                            {t('pages.risks.tabs.options.are_links_visible')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'allLinks',
                                    !areLinksVisible
                                );
                            }}
                        >
                            {areLinksVisible ? 1 : 0}
                        </Weight>
                    </Flex>

                    <Flex className="mb-05">
                        <div style={{ width: "95%" }} className="text-left">
                            {t('pages.risks.tabs.options.chart_visible_stakes')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'stakesChart',
                                    !showStakes
                                );
                            }}
                        >
                            {showStakes ? 1 : 0}
                        </Weight>
                    </Flex>

                    <Flex className="mb-05">
                        <div style={{ width: "95%" }} className="text-left">
                            {t('pages.risks.tabs.options.chart_visible_risks')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'risksChart',
                                    !showRisks
                                );
                            }}
                        >
                            {showRisks ? 1 : 0}
                        </Weight>
                    </Flex>

                    <Flex className="mb-05">
                        <div style={{ width: "95%" }} className="text-left">
                            {t('pages.risks.tabs.options.chart_visible_opportunities')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'opportunitiesChart',
                                    !showOpportunities
                                );
                            }}
                        >
                            {showOpportunities ? 1 : 0}
                        </Weight>
                    </Flex>

                    <Flex className="mb-05">
                        <div style={{ width: "95%" }} className="text-left">
                            {t('pages.risks.tabs.options.chart_visible_stakeholders')}
                        </div>
                        <Weight
                            count={1}
                            onClick={() => {
                                props.setPreferences(
                                    'stakeholdersChart',
                                    !showStakeholders
                                );
                            }}
                        >
                            {showStakeholders ? 1 : 0}
                        </Weight>
                    </Flex>

                </div>
            </>}

        </div >
    );
}